module.exports = "<list-for-observable *ngIf=\"itemsObservable\" [itemsObservable]=itemsObservable [date]=date></list-for-observable>\n"


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/ListForDate.component.html
// module id = ../../../../../src/app/items/ListForDate.component.html
// module chunks = main